import "./App.css";
import React from "react";
import { PortFolio } from "./pages/PortFolio";

function App() {
  return (
    <div>
      <PortFolio />
    </div>
  );
}

export default App;
